import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

// A page with no title of its own takes index.html's.
@Injectable()
export class PageTitleStrategy extends TitleStrategy {
    private readonly title = inject(Title);
    private readonly defaultTitle = this.title.getTitle();

    override updateTitle(snapshot: RouterStateSnapshot): void {
        this.title.setTitle(this.buildTitle(snapshot) ?? this.defaultTitle);
    }
}
